var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8CarteBancaireFaceArrire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "96px",
    height: "96px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 8.5 9 C 4.9280619 9 2 11.928062 2 15.5 L 2 32.5 C 2 36.071938 4.9280619 39 8.5 39 L 39.5 39 C 43.071938 39 46 36.071938 46 32.5 L 46 15.5 C 46 11.928062 43.071938 9 39.5 9 L 8.5 9 z M 8.5 12 L 39.5 12 C 41.450062 12 43 13.549938 43 15.5 L 43 17 L 5 17 L 5 15.5 C 5 13.549938 6.5499381 12 8.5 12 z M 5 21 L 43 21 L 43 32.5 C 43 34.450062 41.450062 36 39.5 36 L 8.5 36 C 6.5499381 36 5 34.450062 5 32.5 L 5 21 z M 31.5 29 A 1.50015 1.50015 0 1 0 31.5 32 L 37.5 32 A 1.50015 1.50015 0 1 0 37.5 29 L 31.5 29 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8CarteBancaireFaceArrire);
export default __webpack_public_path__ + "static/media/icons8-carte-bancaire-face-arrière.dd34d371cc0aa9c4ec514a29d458126a.svg";
export { ForwardRef as ReactComponent };